"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AERIS_ATTRIBUTION = void 0;
const AERIS_ATTRIBUTION = exports.AERIS_ATTRIBUTION = 'Weather data &copy; <a href="https://www.xweather.com/" target="_blank">Vaisala Xweather</a>';